export const copyTextToClipboard = async (
  text: string,
  options: { mountTarget?: Element } = {}
): Promise<boolean> => {
  if (!text) return false;

  try {
    if (navigator.clipboard?.writeText && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // Fall back to legacy copy for non-secure contexts (e.g. HTTP dev hosts).
  }

  try {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    textarea.style.top = '0';
    // Mounting inside the caller's own container (e.g. a focus-trapped Radix
    // menu item) — rather than always document.body — matters when the
    // caller lives inside a focus trap: the trap's "focus left the
    // container" guard fires synchronously on our own `textarea.focus()`
    // call below and yanks focus straight back before execCommand runs,
    // silently no-op'ing the copy. Appending inside the trap satisfies its
    // containment check instead of fighting it.
    (options.mountTarget ?? document.body).appendChild(textarea);
    textarea.focus();
    textarea.select();
    textarea.setSelectionRange(0, text.length);

    const copied = document.execCommand('copy');
    textarea.remove();
    return copied;
  } catch {
    return false;
  }
};
